import { render, staticRenderFns } from "./AdminCreateOrg.vue?vue&type=template&id=60cc4720"
import script from "./AdminCreateOrg.vue?vue&type=script&lang=js"
export * from "./AdminCreateOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports